import { jsx as _jsx } from "react/jsx-runtime";
import { useBreakpoint } from '../../../../hooks';
import { PAGE_BREAKPOINTS } from '../../../../constants/commonConstants';
import { Conditional } from '../../../common';
import { EquipmentName, EquipmentNameTooltip } from '../../my-equipment-list';
export const EquipmentLabel = ({ label, variant = 'display-sm', searchTerm, isVirtualScroll = false }) => {
    const isLG = useBreakpoint(PAGE_BREAKPOINTS.BLOCKS_LG);
    return (_jsx(Conditional, { test: !!isLG, fallback: _jsx(EquipmentName, { variant: variant, text: label, textToHighlightTerm: searchTerm, isVirtualScroll: isVirtualScroll }), children: _jsx(EquipmentNameTooltip, { toolTipContent: label, children: _jsx(EquipmentName, { variant: variant, text: label, textToHighlightTerm: searchTerm, isVirtualScroll: isVirtualScroll }) }) }));
};
